import { useGetEntity } from '@abaninja/util-store';

import { getDocumentDownloadPath } from '../documents';

export const useDocumentDownloadPath = () => useGetEntity(getDocumentDownloadPath);
